import PropTypes from 'prop-types';

import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';

export default function PersonalInfoCard({
  isVerifyingCpf,
  getErrorMessageByFieldName,
  cpf,
  handleCpfChange,
  name,
  handleNameChange,
  email,
  handleEmailChange,
  rg,
  handleRgChange,
  motherName,
  handleMotherNameChange,
  birthDate,
  handleBirthDateChange,
  isVtRegistration,
  // cellphone,
  // handleCellphoneChange,
}) {
  return (
    <>
      <div className="title">
        Para começar, informe seus dados pessoais.
      </div>
      <FormGroup isLoading={isVerifyingCpf} error={getErrorMessageByFieldName('cpf')}>
        <Input
          placeholder="CPF"
          value={cpf}
          onChange={handleCpfChange}
          maxLength="14"
          disabled={isVerifyingCpf}
          error={getErrorMessageByFieldName('cpf')}
        />
      </FormGroup>
      <FormGroup error={getErrorMessageByFieldName('name')}>
        <Input
          placeholder="Nome completo"
          value={name}
          onChange={handleNameChange}
          error={getErrorMessageByFieldName('name')}
        />
      </FormGroup>
      <FormGroup error={getErrorMessageByFieldName('email')}>
        <Input
          placeholder="E-mail"
          value={email}
          onChange={handleEmailChange}
          error={getErrorMessageByFieldName('email')}
        />
      </FormGroup>

      {isVtRegistration && (
        <>
          <FormGroup error={getErrorMessageByFieldName('rg')}>
            <Input
              placeholder="RG"
              value={rg}
              onChange={handleRgChange}
              maxLength="12"
              error={getErrorMessageByFieldName('rg')}
            />
          </FormGroup>
          <FormGroup error={getErrorMessageByFieldName('motherName')}>
            <Input
              placeholder="Nome da mãe completo"
              value={motherName}
              onChange={handleMotherNameChange}
              error={getErrorMessageByFieldName('motherName')}
            />
          </FormGroup>
          <FormGroup error={getErrorMessageByFieldName('birthDate')}>
            <label
              htmlFor="birthDate"
              style={{
                fontSize: '12px',
                color: '#bcbcbc',
                marginBottom: '4px',
                display: 'block',
              }}
            >
              Data de nascimento
            </label>
            <Input
              id="birthDate"
              value={birthDate}
              onChange={handleBirthDateChange}
              type="date"
              error={getErrorMessageByFieldName('birthDate')}
            />
          </FormGroup>
        </>
      )}
      {/* <FormGroup error={getErrorMessageByFieldName('cellphone')}>
        <Input
          placeholder="Celular (WhatsApp)"
          value={cellphone}
          onChange={handleCellphoneChange}
          error={getErrorMessageByFieldName('cellphone')}
        />
      </FormGroup> */}
    </>
  );
}

PersonalInfoCard.propTypes = {
  isVerifyingCpf: PropTypes.bool.isRequired,
  getErrorMessageByFieldName: PropTypes.func.isRequired,
  cpf: PropTypes.string.isRequired,
  handleCpfChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  rg: PropTypes.string.isRequired,
  handleRgChange: PropTypes.func.isRequired,
  motherName: PropTypes.string.isRequired,
  handleMotherNameChange: PropTypes.func.isRequired,
  birthDate: PropTypes.string.isRequired,
  handleBirthDateChange: PropTypes.func.isRequired,
  isVtRegistration: PropTypes.bool.isRequired,
  // cellphone: PropTypes.string.isRequired,
  // handleCellphoneChange: PropTypes.func.isRequired,
};
